<template>
	<div class="page-wrap">
		<ActionsBar pageTitle="orders"/>

		<v-card pa-4 v-if="!loader">
			<div class="data-wrap mt-4">
				<v-expansion-panels class="orders">
					<v-expansion-panel v-for="(item, key) in list" :key="key">
						<v-expansion-panel-header>
							<div><div class="status-wrap"><span :class="item.status + ' status'">{{ item.status }}</span></div></div>
							<div>{{ parseDate(item.created_at) }}</div>
						</v-expansion-panel-header>
						<v-expansion-panel-content>
							<div class="order-details">
								<div class="details-block">
									<div class="headline">Customer data</div>



									<div class="order-data">
										<div >
											<p><span>Name:</span> {{ item.contact_name }}</p>
											<p><span>Email:</span> {{ item.contact_email }}</p>
											<p><span>Phone:</span> {{ item.contact_phone }}</p>
										</div>

										<div>
											<p><span>Delivery date:</span> {{ parseDate(item.delivery[0].date) }}</p>
											<p><span>Comment:</span> {{ item.comment }}</p>
										</div>
									</div>

									<div class="addresses">
										<p v-for="(addressItem, index) in item.delivery" :key="index"><span>Address:</span> {{ addressItem.address.street_address + ' ' + addressItem.address.city + ' ' + addressItem.address.postal_code }}</p>
									</div>
								</div>

								<div class="details-block">
									<div class="headline">Products data</div>

									<div class="items">
										<v-card class="item" v-for="(product, index) in item.items.items" :key="index">
											<v-img :src="product.attributes.preview" height="200px"></v-img>

											<v-card-title>{{product.title}}</v-card-title>

											<v-card-subtitle><span>Price: {{product.price}}</span> <span>Quantity: {{product.quantity}}</span></v-card-subtitle>

											<v-card-subtitle style="font-size: 1.2rem!important;">{{ product.attributes.description }}</v-card-subtitle>
										</v-card>
									</div>
								</div>

								<div class="order-bottom">
									<span class="subtotal">Total: <span>{{item.items.subtotal}}</span></span>

									<a :href="'/front/invoice/' + item.uid" v-if="item.status !== 'New'" target="_blank">Rechnung</a>
									<a :href="'/front/delivery-note/' + item.uid" v-if="item.status !== 'New'" target="_blank">Lieferung</a>
									<v-btn v-if="item.status !== 'Completed'" @click="openCloseOrder(item.uid)" color="primary" outlined>Close order</v-btn>
								</div>
							</div>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>

				<div class="load-more">
					<v-btn @click="loadMore"><v-icon>mdi-reload</v-icon> Load more</v-btn>
				</div>
			</div>
		</v-card>

		<div v-else class="loader">
			<v-progress-circular indeterminate color="primary"></v-progress-circular>
		</div>

		<v-dialog v-model="dialog" width="500">

			<v-card>
				<v-card-title >
					Ist die Bestellung wirklich abgeschlossen?
				</v-card-title >

				<v-divider></v-divider>

				<v-card-actions>
					<v-btn color="primary" text @click="itemToClose = ''; dialog = false"> Nein </v-btn>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="closeOrder()"> Ja </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<DeleteDialog :modal="deleteModal" :item="selectedItem" :action="action" :close="() => {closeDelete()}"/>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import moment from 'moment';
	import ActionsBar from '../components/ActionsBar/ActionsBar.vue';
	import DeleteDialog from '../components/FormModal/DeleteDialog.vue';

	export default {
		name: 'Orders',
		components: { ActionsBar, DeleteDialog },
		data: () => {
			return {
				loader: false,
				dialog: false,
				itemToClose: '',
				modal: false,
				deleteModal: false,
				action: '',
				selectedItem: {},
				headers: [
					{ text: 'Status', value: 'status' },
					{ text: 'Date', value: 'created_at' }
				],
				expanded: [],
				singleExpand: true
			}
		},

		watch: {
			list(val){
				if(val){
					this.loader = false;
				}
			}
		},

		computed: {
			...mapState('Orders', ['list'])
		},

		mounted(){
			this.loader = true;

			this.$store.dispatch('Orders/list');
		},

		methods: {
			loadMore(){
				this.$store.dispatch('Orders/list', 'load');
			},

			parseDate(date){
				return moment(date).format('YYYY-MM-DD H:mm');
			},

			openCloseOrder(id){
				this.itemToClose = id;
				this.dialog = true;
			},

			closeOrder(){
				this.$store.dispatch('Orders/remove', this.itemToClose);
				this.dialog = false;
				this.itemToClose = '';
			},

			closeModal(){
				this.modal = false;
				this.selectedItem = {};
				this.action = {};
			},

			deleteItem(item){
				this.deleteModal = true;
				this.selectedItem = Object.assign({}, item);
				this.action = 'Orders/remove';
			},

			closeDelete(){
				this.deleteModal = false;
				this.selectedItem = {};
				this.action = '';
			}
		}
	}
</script>

<style>

</style>
